export const ADD_CAMPAIGN_DETAILS = 'ADD_CAMPAIGN_DETAILS';
